import React, { useState, useEffect } from "react";
import classes from './CashManage.module.css';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import { useLocation, useNavigate } from "react-router-dom";
import { Eye, Printer, Trash } from "lucide-react";
import filterIcon from "../../Assets/SVG (1).png";
import dateIcon from "../../Assets/SVG (2).png";
import exported from "../../Assets/SVG (4).png";
import svg from "../../Assets/SVG.jpg";
import Footer from "../../Components/Footer/Footer";
import CashReciept from "./CashReciept/CashReciept";
import api, { BASE_URL, withCompanyId } from "../../Components/API/Api";
import Swal from 'sweetalert2';

const Generalledger = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const [selectMetrics, setSelectedMetrics] = useState(null);
    const [receipts, setReceipts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [openCashReciept, setOpenCashReciept] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [perPage, setPerPage] = useState(100);
    const [totalRecords, setTotalRecords] = useState(0);

    const [searchTerm, setSearchTerm] = useState("");
    const [filterTerm, setFilterTerm] = useState("");
    const [dateRange, setDateRange] = useState("");
    const [showSearchDropdown, setShowSearchDropdown] = useState(false);
    const [showFilterDropdown, setShowFilterDropdown] = useState(false);
    const [showDateDropdown, setShowDateDropdown] = useState(false);
    const filteredReceipts = receipts.filter((item) => {
        const receiptNumber = item.receipt_number || "";
        return receiptNumber.toLowerCase().includes(searchTerm?.toLowerCase() || "");
    });


    const [baseCurrencyCode, setBaseCurrencyCode] = useState("NGN");

    useEffect(() => {
        const getBaseCurrencyCode = async () => {
            try {
                const token = localStorage.getItem("authToken");

                // STEP 1: Get currency ID from company info
                const companyRes = await api.get(`/v1/companies/get-info`);

                const companyData = Array.isArray(companyRes?.data?.data)
                    ? companyRes.data.data[0]
                    : companyRes?.data?.data;

                const currencyId = companyData?.currency_base; // This gives us the ID (e.g., "134")

                // STEP 2: Get all currencies to find the code
                const currenciesRes = await api.get(`/v1/fetch-all-currencies`);

                if (currenciesRes.data?.data && Array.isArray(currenciesRes.data.data)) {
                    // STEP 3: Find the currency with matching ID and get its code
                    const baseCurrency = currenciesRes.data.data.find(
                        currency => String(currency.id) === String(currencyId)
                    );

                    if (baseCurrency && baseCurrency.code) {
                        setBaseCurrencyCode(baseCurrency.code); // This gives us "MAD", "USD", etc.
                    } else {
                        setBaseCurrencyCode("NGN"); // Fallback
                    }
                }

            } catch (err) {
                console.error("Failed to fetch base currency", err);
                setBaseCurrencyCode("NGN"); // Fallback
            }
        };

        getBaseCurrencyCode();
    }, []);

    // Fetch receipts with pagination
    useEffect(() => {
        const fetchReceipts = async () => {
            try {
                setLoading(true);
                const res = await api.get(`/v1/fetch-receipts?page=${currentPage}`);
                const paginationData = res.data?.data;
                const receiptsData = Array.isArray(paginationData?.data) ? paginationData.data : [];
                
                console.log("Fetched receipts page:", currentPage, "Last page:", paginationData?.last_page);
                setReceipts(receiptsData);
                setLastPage(paginationData?.last_page || 1);
                setPerPage(paginationData?.per_page || 100);
                setTotalRecords(paginationData?.total || 0);
            } catch (err) {
                console.error("Error fetching receipts:", err);
                setReceipts([]);
            } finally {
                setLoading(false);
            }
        };
        fetchReceipts();
    }, [currentPage]);

    const handleReceiptSuccess = () => {
        // Reset to first page after adding a new receipt
        setCurrentPage(1);
    };

    // Pagination controls
    const handleFirstPage = () => setCurrentPage(1);
    const handleLastPage = () => setCurrentPage(lastPage);
    const handlePrevPage = () => setCurrentPage(prev => Math.max(prev - 1, 1));
    const handleNextPage = () => setCurrentPage(prev => Math.min(prev + 1, lastPage));
    const handlePageChange = (page) => {
        if (page >= 1 && page <= lastPage) {
            setCurrentPage(page);
        }
    };

    // Fetch metrics
    useEffect(() => {
        const fetchMetrics = async () => {
            try {
                const token = localStorage.getItem("authToken");
                const res = await api.get(`/v1/metrics/journal-entries-metrics`);
                if (res.data?.status && res.data?.data) {
                    setSelectedMetrics(res.data.data);
                }
            } catch {
                setSelectedMetrics(null);
            }
        };
        fetchMetrics();
    }, []);

    // Filtered receipts based on search, filter, and date range


    const pageMap = {
        '/dashboard': 'Dashboard',
        '/transactions': 'Transactions',
        '/accounts': 'Accounting',
        '/reports': 'Reports',
        '/banking': 'Banking',
        '/settings': 'Settings',
    };

    // NEW: navigate to the payment/receipt route and pass the clicked receipt as "payment"
    const handleOpenReceipt = (receipt) => {
        navigate('/payment-receipt', { state: { payment: receipt } });
    };

    const handleReverseReceipt = async (item) => {
        // Confirm deletion
        const result = await Swal.fire({
            title: 'Reverse Receipt',
            text: 'Are you sure you want to reverse this receipt? This action cannot be undone.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, reverse it!'
        });

        if (!result.isConfirmed) {
            return;
        }

        try {
            const response = await api.post(`/v1/reverse-receipt`, withCompanyId({
                uuid: item.uuid
            }));

            if (response.data?.success === true || response.data?.status === true || (
                response.status >= 200 && response.status < 300 &&
                response.data?.success !== false && response.data?.status !== false
            )) {
                setReceipts(currentReceipts => currentReceipts.filter(receipt => receipt.uuid !== item.uuid));
                setTotalRecords(total => Math.max(total - 1, 0));
                Swal.fire({
                    title: 'Success!',
                    text: 'Receipt reversed successfully.',
                    icon: 'success',
                    confirmButtonColor: '#3085d6'
                });
            } else {
                Swal.fire({
                    title: 'Error!',
                    text: response.data?.message || 'Error reversing receipt. Please try again.',
                    icon: 'error',
                    confirmButtonColor: '#3085d6'
                });
            }
        } catch (error) {
            console.error("Failed to reverse receipt:", error);
            // Get error message from backend response
            const errorMessage = error.response?.data?.message || 'Error reversing receipt. Please try again.';
            
            Swal.fire({
                title: 'Error!',
                text: errorMessage,
                icon: 'error',
                confirmButtonColor: '#3085d6'
            });
        }
    };

    return (
        <div>
            <HeaderNav activePage={pageMap[location.pathname]} />
            <div className={classes.Container}>
                {/* Actions */}
                <div className={classes.actions}>
                    <button className={classes.btns}>New Sales Invoice</button>
                    <button className={classes.btns}>New Purchase Invoice</button>
                    <button className={classes.btns}>All Invoices</button>
                    <button className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
                </div>

                <header className={classes.Header}>
                    <h2 className={classes.Title}>Cash Management</h2>
                    <h1 className={classes.Titles}>
                        View all accounting transactions and account balances in chronological order.
                    </h1>
                </header>

                <div className={classes.entrjj}>
                    <div className={classes.allkads}>
                        <div className={classes.thrdkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Total debits</p>
                                <p className={classes.kdptg1}>{selectMetrics?.total_debits?.toLocaleString() ?? '0'}</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>This period</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.frtkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Total Credits</p>
                                <p className={classes.kdptg2}>{selectMetrics?.total_credits?.toLocaleString() ?? '0'}</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>This period</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.fiftkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Trial balance</p>
                                <p className={classes.kdptg3}>{selectMetrics?.trial_balance?.toLocaleString() ?? '0'}</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Balanced</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.frstkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Entries</p>
                                <p className={classes.kdptg4}>{selectMetrics?.total_entries?.toLocaleString() ?? '0'}</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>This month</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={classes.headerActions}>
                    <div className={classes.actionsRight}>
                        <div className={classes.inputWrapper}>
                            <img src={svg} alt="search" className={classes.searchIcon} />
                            <div
                                className={classes.searchLedgerEditable}
                                contentEditable
                                suppressContentEditableWarning={true}
                                placeholder="Search ledger..."
                                onInput={(e) => setSearchTerm(e.currentTarget.textContent)}
                            ></div>
                        </div>



                        {/* ===== FILTER DROPDOWN ===== */}
                        <div className={classes.inputWrapper}>
                            <img src={filterIcon} alt="filter" className={classes.filterIcon} />
                            <div className={classes.filterDropdown}>
                                <div
                                    className={classes.selected}
                                    onClick={() => setShowFilterDropdown(!showFilterDropdown)}
                                >
                                    {filterTerm || "Filter by payment mode..."}
                                </div>
                                {showFilterDropdown && (
                                    <div className={classes.options}>
                                        {/* Reset option */}
                                        <div
                                            className={classes.option}
                                            onClick={() => {
                                                setFilterTerm("");
                                                setShowFilterDropdown(false);
                                            }}
                                        >
                                            All / Reset
                                        </div>

                                        {/* Unique payment modes */}
                                        {Array.from(
                                            new Set(receipts.map(r => r.mode?.name).filter(Boolean))
                                        ).map((mode, idx) => (
                                            <div
                                                key={idx}
                                                className={classes.option}
                                                onClick={() => {
                                                    setFilterTerm(mode);
                                                    setShowFilterDropdown(false);
                                                }}
                                            >
                                                {mode}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* ===== DATE RANGE DROPDOWN ===== */}
                        <div className={classes.inputWrapper}>
                            <img src={dateIcon} alt="date" className={classes.dateicon} />
                            <div className={classes.dateDropdown}>
                                <div
                                    className={classes.selected}
                                    onClick={() => setShowDateDropdown(!showDateDropdown)}
                                >
                                    {dateRange || "Select date range..."}
                                </div>
                                {showDateDropdown && (
                                    <div className={classes.options}>
                                        <div
                                            className={classes.option}
                                            onClick={() => {
                                                setDateRange("2025-10-01 - 2025-10-13");
                                                setShowDateDropdown(false);
                                            }}
                                        >
                                            2025-10-01 - 2025-10-13
                                        </div>
                                        <div
                                            className={classes.option}
                                            onClick={() => {
                                                setDateRange("2025-09-01 - 2025-09-30");
                                                setShowDateDropdown(false);
                                            }}
                                        >
                                            2025-09-01 - 2025-09-30
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                    </div>
                    <div className={classes.inputWrapper}>
                        <button className={classes.btnss}
                            onClick={() => setOpenCashReciept(true)}>
                            <img src={exported} alt="added"
                                className={classes.invoiceIcon} />
                            Cash Receipt
                        </button>
                    </div>
                </div>

                {/* Table */}
                <div className={classes.tableContainer}>
                    <table className={classes.table}>
                        <thead>
                            <tr className={classes.tableHeader}>
                                <th>Date</th>
                                <th>Receipt No</th>
                                <th>Received From</th>
                                <th>Description</th>
                                <th>Currency</th>
                                <th>Amount</th>
                                <th>{baseCurrencyCode} Amount</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                [...Array(8)].map((_, i) => (
                                    <tr key={i}>
                                        {Array(8).fill().map((__, j) => (
                                            <td key={j}>
                                                <div className={classes.skeleton}></div>
                                            </td>
                                        ))}
                                    </tr>
                                ))
                            ) : filteredReceipts.length === 0 ? (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: "center", padding: "15px" }}>
                                        No receipts found
                                    </td>
                                </tr>
                            ) : (
                                filteredReceipts.map((item, index) => (
                                    <tr key={index} className={classes.tableRow}>
                                        <td className={classes.tableCell}>{item.transaction_date}</td>
                                        <td className={classes.tableCell}>{item.uuid}</td>
                                        <td className={classes.tableCell}>{item.particular || item.customer?.name || "—"}</td>
                                        <td className={classes.tableCell}>{item.description || "—"}</td>
                                        <td className={classes.tableCell}>{item.currency?.currency || "—"}</td>
                                        <td style={{ paddingRight: "4px", textAlign: "right" }}>
                                            {parseFloat(item.total_currency_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                            {parseFloat(item.total_converted_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </td>

                                        <td className={`${classes.tableCell} ${classes.iconActions}`}>
                                            <Eye size={16} style={{ color: "rgb(22,163,74)" }} />
                                            {/* make printer clickable to view full receipt */}
                                            <span
                                                onClick={() => handleOpenReceipt(item)}
                                                role="button"
                                                tabIndex={0}
                                                onKeyDown={(e) => { if (e.key === 'Enter') handleOpenReceipt(item); }}
                                                style={{ margin: "0 8px", color: "rgb(37, 99, 235)", cursor: "pointer" }}
                                                aria-label={`Open receipt ${item.invoice_number || item.receipt_number || item.uuid}`}
                                            >
                                                <Printer size={16} />
                                            </span>
                                            <Trash
                                                size={16}
                                                style={{ color: "rgb(255, 2, 2)", cursor: "pointer" }}
                                                onClick={() => handleReverseReceipt(item)}
                                            />
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <table className={classes.footerTable}>
                    <tfoot>
                        <tr>
                            <td className={`${classes.frston} ${currentPage === 1 ? classes.disabled : ''}`} onClick={handleFirstPage}>First</td>
                            <td className={`${classes.page} ${currentPage === 1 ? classes.activePage : ''}`} onClick={() => handlePageChange(1)}>1</td>
                            {lastPage > 1 && (
                                <>
                                    {currentPage > 3 && <td className={classes.page}>...</td>}
                                    {Array.from({ length: Math.min(3, lastPage - 1) }, (_, i) => {
                                        const pageNum = i + 2;
                                        if (pageNum <= lastPage) {
                                            return (
                                                <td
                                                    key={pageNum}
                                                    className={`${classes.page} ${currentPage === pageNum ? classes.activePage : ''}`}
                                                    onClick={() => handlePageChange(pageNum)}
                                                >
                                                    {pageNum}
                                                </td>
                                            );
                                        }
                                        return null;
                                    })}
                                    {currentPage < lastPage - 2 && lastPage > 4 && <td className={classes.page}>...</td>}
                                    {lastPage > 1 && (
                                        <td
                                            className={`${classes.page} ${currentPage === lastPage ? classes.activePage : ''}`}
                                            onClick={() => handlePageChange(lastPage)}
                                        >
                                            {lastPage}
                                        </td>
                                    )}
                                </>
                            )}
                            <td className={`${classes.lastno} ${currentPage === lastPage ? classes.disabled : ''}`} onClick={handleLastPage}>Last</td>
                        </tr>
                    </tfoot>
                </table>
                <div className={classes.paginationDisplay}>
                    Displaying {(currentPage - 1) * perPage + 1} - {Math.min(currentPage * perPage, totalRecords)} of {totalRecords}
                </div>
            </div>

            <CashReciept isOpen={openCashReciept} onClose={() => setOpenCashReciept(false)} onSuccess={handleReceiptSuccess} />
            <Footer />
        </div>
    );
};

export default Generalledger;
